<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <contractor-control></contractor-control>
      <contractor-view></contractor-view>
    </v-layout>
  </v-container>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import ContractorControl from "@/components/contractors/contractorControl";
import ContractorView from "@/components/contractors/contractorView";

export default {
  components: {
    ContractorControl,
    ContractorView
  }
};
</script>

<style scoped>
.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
        /* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
